import { ICategorySoldProducts } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { isEqualProductsCount } from './isEqualProductsCount'

interface IIsCategoryIndeterminate {
  selectedData: ICategorySoldProducts[]
  categoryKey: string
  staticData: ICategorySoldProducts[]
}

export const isCategoryIndeterminate = ({
  selectedData,
  categoryKey,
  staticData,
}: IIsCategoryIndeterminate) => {
  if (!selectedData) {
    return false
  }

  const foundCategory = selectedData.find((el) => el.Key === categoryKey)

  return Boolean(foundCategory) && !isEqualProductsCount({ selectedData, categoryKey, staticData })
}
